export const QRCode = {
    main_point_collection: {
        text_scan: 'สแกน QR Code',
        text_collect: 'สะสม',
        text_point: 'พอยท์',
        btn_scan_qr: 'เริ่มสแกน QR Code',
        btn_point_product: 'ดูพอยท์แต่ละสินค้า'
    },
    code: {
        name: '',
        placeholder: 'กรอกรหัสด้านล่าง QR Code',
        required: 'กรุณากรอกรหัสด้านล่าง QR Code',
        too_short: '',
        invalid: '',
    },
    alert_qr_code: {
        title: 'สแกนไม่สำเร็จ',
        text: 'QR Code ไม่ถูกต้อง<br/>กรุณาลองใหม่อีกครั้ง',
        btn_again: 'สแกนอีกครั้ง',
        btn_cancel: 'ยกเลิก'
    },
    scan_qr: {
        title: 'สแกน QR Code',
        text_pls_scan: 'กรุณาสแกน QR Code',
        text_contact: 'หากพบปัญหากรุณาติดต่อ',
        text_or: 'หรือ',
        text_select_image: 'เลือกรูป',
        text_camera: 'เปิดกล้อง',
        text_condition: 'กรณีที่ไม่สามารถสแกน QR Code<br>หรือเลือกรูปได้ กรุณากรอกรหัสด้วยตนเอง',
        text_line_add: '@BiodermaThailand',
        btn_confirm: 'ยืนยัน',
        btn_cancel: 'ยกเลิก',
    },
    summary: {
        text_receive: 'คุณได้รับพอยท์',
        text_check: 'กรุณาตรวจสอบสิทธิ์ในประวัติการแลกพอยท์',
        text_check_mission: 'กรุณาตรวจสอบสิทธิ์ในประวัติการแลกพอยท์',
        text_success: 'ภารกิจสำเร็จแล้ว! คุณได้รับ',
        btn_next: 'สแกนต่อ',
        btn_history: 'ดูประวัติการสะสมพอยท์',
    },
    product_detail:{
        title: 'รายละเอียดผลิตภัณฑ์',
        text_point: 'พอยท์ที่ได้รับ',
        btn_confirm: 'ยืนยัน',
    },
    errorText: {
        notFound: 'ไม่พบรหัสนี้ในระบบ โปรดกรอกหรือสแกนรหัสใหม่อีกครั้ง<br>กรณีกรอกหรือสแกนรหัสผิดครบ 20 ครั้ง<br>บัญชีของท่านจะถูกระงับการใช้งาน',
        used: 'รหัสนี้ถูกใช้ไปแล้ว',
        suspend: 'บัญชีของท่านถูกระงับการใช้งาน<br>เนื่องจากกรอก หรือสแกนรหัสผิดครบ 20 ครั้ง'
    }
}